module.exports = __webpack_public_path__ + "media/a1.868da3ef.wav";